import React from "react";
import ReactDOM from "react-dom";
import "../../../styles/AdminPanel/EditModal.css";

export default function EditModal({ children, onClose }) {
  let modalRoot = document.getElementById("modal-root");

  if (!modalRoot) {
    modalRoot = document.createElement("div");
    modalRoot.id = "modal-root";
    document.body.appendChild(modalRoot);
  }

  return ReactDOM.createPortal(
    <>
      <div className="modal-overlay" onClick={onClose}></div>

      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </>,
    modalRoot
  );
}